import React from 'react'
import Button from 'component/Buttons/login-button'
import SecondaryBtn from 'component/Buttons/secondary-btn'
import InputFieldOutlined from 'component/Inputs/dashboard-input'
import Modal from 'component/modal'
import { Form, Formik } from 'formik'
import * as yup from 'yup'
import { usePlan } from './plan.context'
import Api from 'utils/api'
import Select from 'component/Select/select'

const PlansInfo = yup.object({
  productname: yup.string().label('Name'),
  amount: yup.number().label('Email'),
  currency: yup.string().label('Bikes Count'),
  interval: yup.string().label('Address'),
  hoursLimit: yup.number().label('City'),
})

function CreatePlan() {
  const { openModal, setOpenModal, plans, setPlans, selectedPlan } = usePlan()
  const isUpdate = Boolean(selectedPlan)

  const initState = {
    productname: selectedPlan?.productname || '',
    amount: selectedPlan?.amount || '',
    currency: selectedPlan?.currency || '',
    interval: selectedPlan?.interval || '',
    hoursLimit: selectedPlan?.hoursLimit || '',
    customizedPlan: selectedPlan?.customizedPlan || true,
  }

  const onClose = () => {
    setOpenModal(false)
  }

  const handleSubmit = async (form, { setSubmitting }) => {
    if (isUpdate) {
      form._id = selectedPlan._id
    }

    const { response } = await Api(`/plans`, isUpdate ? 'put' : 'post', {
      payload: form,
    })

    if (response) {
      if (isUpdate) {
        const idx = plans.findIndex((item) => item._id == selectedPlan._id)
        plans[idx] = response.data
        setPlans([...plans])
      } else {
        setPlans([...plans, response.data])
      }
    }

    setSubmitting(false)
    onClose()
  }

  return (
    <Modal open={openModal} onClose={onClose}>
      <Formik
        initialValues={initState}
        validationSchema={PlansInfo}
        onSubmit={handleSubmit}
        isInitialValid={false}
      >
        {({ values, errors, isSubmitting }) => (
          <Form className='max-w-3xl'>
            <div className='p-3 md:p-5'>
              <div className='p-3'>Plans</div>
              <hr />
              <div className='p-3'>
                <div className='form-content'>
                  {console.log('VALUES', values)}
                  <div class='grid gap-6 mb-6 md:grid-cols-2'>
                    <InputFieldOutlined
                      label={'Name'}
                      name={'productname'}
                      type={'text'}
                      placeholder={''}
                    />

                    <InputFieldOutlined
                      label={'Currency'}
                      name={'currency'}
                      type={'text'}
                      placeholder={''}
                    />

                    <InputFieldOutlined
                      label={'Amount'}
                      name={'amount'}
                      type={'number'}
                      placeholder={''}
                    />

                    <div>
                      <Select
                        label={'Interval'}
                        name={'interval'}
                        options={[
                          {
                            label: 'One Time',
                            value: 'oneTime',
                          },
                          {
                            label: 'Month',
                            value: 'month',
                          },
                        ]}
                      />
                    </div>

                    <InputFieldOutlined
                      label={'Hours Limit'}
                      name={'hoursLimit'}
                      type={'number'}
                      placeholder={''}
                    />
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-end p-4 border-t border-gray-200 rounded-b '>
                {!values.edit && (
                  <Button processing={isSubmitting} type={'submit'}>
                    Confirm
                  </Button>
                )}
                <SecondaryBtn onClick={onClose} label={'Cancel'} />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default CreatePlan
